export default __webpack_public_path__ + "static/media/leaf.7a897455.png";